
export default {
  name: "IconMenu"
}
